module.exports = __webpack_public_path__ + "static/media/bg.136f0ced.svg";